import { render } from "./PayHeader.vue?vue&type=template&id=c89ada0c"
import script from "./PayHeader.vue?vue&type=script&lang=js"
export * from "./PayHeader.vue?vue&type=script&lang=js"

import "./PayHeader.vue?vue&type=style&index=0&id=c89ada0c&lang=css"

import exportComponent from "/opt/apps/golden_telecom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__